import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';

const ModalLanguage = (props) => {

    const { i18n, t} = useTranslation();

  	const ModalClose = () => {
  		props.closeModal();
  	};

    const onChangeLanguage = (language) => {
        i18n.changeLanguage(language)
    }
    
    return (
        <div
        className="modal"
        style={{ display: props.show?'block':'none'}}
      >
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Change Lanauage</Modal.Title>
          </Modal.Header>
  
          <Modal.Body>
          <div className="my_list" data-aos="fade-left">
            <b>{t('language.korean')}</b>
            <span>
                <label className="switch">
                <input type="checkbox" checked = {i18n.language !== 'ko'} onChange={()=>onChangeLanguage('ko')} />
                <span className="slider"></span>
                </label>
            </span>
            </div>
            <div className="my_list" data-aos="fade-left">
            <b>{t('language.english')}</b>
            <span>
                <label className="switch">
                <input type="checkbox"  checked = {i18n.language !== 'en'} onChange={()=>onChangeLanguage('en')}/>
                <span className="slider"></span>
                </label>
            </span>
            </div>
            
          </Modal.Body>
  
          <Modal.Footer>
            <Button className="button" onClick={ModalClose}>Close</Button>
          </Modal.Footer>
        </Modal.Dialog>
      </div>
    );
}

export default ModalLanguage;
